module.exports = __webpack_public_path__ + "static/media/Obedience02.201cec15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Obedience02.jpg
// module id = 344
// module chunks = 0